var path = 'features/pharmacist/templates/training.html';
var html = "<div class=\"section-intro\">\n  <p class=\"section-title\">Training</p>\n</div>\n\n<div ng-if=\"trainingCtrl.loading\" class=\"loader-container\">\n  <div class=\"ui-loader\">\n    <div class=\"ui-spinner\">Loading...</div>\n  </div>\n</div>\n\n<div>\n  <video id=\"training-video\" class=\"full-width\" controls controlsList=\"nodownload\" disablePictureInPicture>\n    <source src=\"https://hmrreferrals.s3-ap-southeast-2.amazonaws.com/HMR+Referrals+Training.mp4\" type=\"video/mp4\">\n  </video>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/features/pharmacist/templates/training.html
 ** module id = 96
 ** module chunks = 0
 **/